import apiPath from '../../../config/api';

const PayablePath = {
    title: "Pembayaran Hutang Supplier",
    basePath: "/akunting/hutang",
    newPath: "/akunting/hutang/baru",
    detailPath: "/akunting/hutang/opsi/:id",
    baseApi: apiPath.accountPayable,
    custFind: apiPath.masterCustFind
}

export default PayablePath;
